module.exports = __webpack_public_path__ + "img/inception-hcms-blue.dce32b86.jpg";